import { styled } from "@mui/material";

export const TableBorder = styled("div")({
  border: "1px solid rgba(0,0,0,.2)",
  borderRadius: 10,
  padding: 7,
  marginTop: 20,
});

export const ActiveContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
});

export const Centered = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
});
